import get from 'lodash/get';
import { DetailType } from 'app/modules/detail-module/data';

export function getPageTitle(type: DetailType, pageParam: string, data: any) {
  if (type === 'donor' || type === 'organisation' || type === 'publisher') {
    return get(data, 'data.name', '') === ''
      ? pageParam.toUpperCase()
      : data.data.name;
  }
  return pageParam;
}
